import script from "./CRMMessengerBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./CRMMessengerBlock.vue?vue&type=script&setup=true&lang=js"

import "./CRMMessengerBlock.vue?vue&type=style&index=0&id=32931e87&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32931e87"]])

export default __exports__